// extracted by mini-css-extract-plugin
module.exports = {"container":"DescriptiveBlockList_container__nTEaQ"};